import { render, staticRenderFns } from "./CallLetter.vue?vue&type=template&id=8f482bca&scoped=true&"
import script from "./CallLetter.vue?vue&type=script&lang=js&"
export * from "./CallLetter.vue?vue&type=script&lang=js&"
import style0 from "./CallLetter.vue?vue&type=style&index=0&id=8f482bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f482bca",
  null
  
)

export default component.exports